import { EProductTourTargets } from '@constants';
import { IReport } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import { StatusCell } from '../StatusCell';

import {
  ReportCard,
  ReportCardLabel,
  ReportCardRow,
  ReportCardValue,
  ReportsList
} from './MobileReportsDetail.styles';

type Props = {
  reports: IReport[];
  problemReportId: string;
  resourceTitle: string;
};

export const MobileReportsDetail: React.FC<Props> = ({
  reports,
  problemReportId,
  resourceTitle
}) => {
  const { t } = useTranslation('ProblemReportsTranslations');
  const { t: tDefault } = useTranslation('DefaultTranslations');
  return (
    <ReportsList>
      {!reports?.length ? (
        <Empty description={t('NO_PROBLEM_REPORTS')} />
      ) : (
        reports.map((report, index) => (
          <ReportCard key={report._id}>
            <ReportCardRow>
              <ReportCardLabel>{t('TITLE')}</ReportCardLabel>
              <ReportCardValue>{tDefault(report.title)}</ReportCardValue>
            </ReportCardRow>
            {report.description && (
              <ReportCardRow>
                <ReportCardLabel>{t('DESCRIPTION')}</ReportCardLabel>
                <ReportCardValue>{report.description}</ReportCardValue>
              </ReportCardRow>
            )}
            <ReportCardRow>
              <ReportCardLabel>{t('REPORTED_BY')}</ReportCardLabel>
              <ReportCardValue>{`${report.reportedBy.name} ${report.reportedBy.lastName}`}</ReportCardValue>
            </ReportCardRow>
            <ReportCardRow>
              <ReportCardLabel>{t('STATUS')}</ReportCardLabel>
              <ReportCardValue>
                <StatusCell
                  status={report.status}
                  problemReportId={problemReportId}
                  reportId={report._id}
                  id={index === 0 ? EProductTourTargets.PROBLEM_REPORT_STATUS_CELL : undefined}
                  userName={`${report.reportedBy.name} ${report.reportedBy.lastName}`}
                  activityName={resourceTitle}
                />
              </ReportCardValue>
            </ReportCardRow>
            <ReportCardRow>
              <ReportCardLabel>{t('CREATION_DATE')}</ReportCardLabel>
              <ReportCardValue>
                {dateProvider.format(report.createdAt, 'dd/MM/yyyy')}
              </ReportCardValue>
            </ReportCardRow>
          </ReportCard>
        ))
      )}
    </ReportsList>
  );
};
